export interface ProjectType {
  name: string
  slug: string
}

export const projectTypes: ProjectType[] = [
  { name: 'React', slug: 'react' },
  { name: 'Vue', slug: 'vue' },
  { name: 'Angular', slug: 'angular' },
  { name: 'JavaScript', slug: 'javascript' },
  { name: 'Laravel', slug: 'laravel' },
  { name: 'NodeJS', slug: 'nodejs' },
  { name: 'ExpressJS', slug: 'expressjs' },
  { name: 'NuxtJS', slug: 'nuxt' },
  { name: 'NextJS', slug: 'nextjs' },
  { name: 'Golang', slug: 'golang' },
  { name: 'Django', slug: 'django' },
  { name: 'FastAPI', slug: 'fastapi' },
  { name: 'FlutterPWA', slug: 'flutter' },
  { name: 'Docker', slug: 'docker' },
  { name: 'Supervisor', slug: 'supervisor' },
  { name: 'LaravelReverb', slug: 'laravel-reverb' },
  { name: 'StaticHTML', slug: 'HTML5' },
  { name: 'Dotnet', slug: 'dotnet' },
]
